import { render, staticRenderFns } from "./BlogpageHe.vue?vue&type=template&id=da99d496&"
import script from "./BlogpageHe.vue?vue&type=script&lang=js&"
export * from "./BlogpageHe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports